import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { TotalIssuePrice } from '../investment-forms/TotalIssuePrice';
import { ExpertRatingTextField } from '../atomic-components/ExpertRatingTextField';
import { AppraisalFirmTextField } from '../atomic-components/AppraisalFirmTextField';
import { ISINTextField } from '../atomic-components/ISINTextField';
import { SPVSelector } from '../atomic-components/SPVSelector';
import { IssueStartDatePicker } from '../atomic-components/IssueStartDatePicker';
import { IssueEndDatePicker } from '../atomic-components/IssueEndDatePicker';
import { IssueFundingFloorPercentageField } from '../atomic-components/IssueFundingFloorPercentageField';
import { SecurityTypeSelector } from '../atomic-components/SecurityTypeSelector';
import { TerminationRightSelector } from '../atomic-components/TerminationRightSelector';
import { TerminationRightFrequencySelector } from '../atomic-components/TerminationRightFrequencySelector';
import { MaturityCheckbox } from '../atomic-components/MaturityCheckbox';
import { MaturityDatePicker } from '../atomic-components/MaturityDatePicker';
import { MinSubscriptionAmountSlider } from '../atomic-components/MinSubscriptionAmountSlider';
import { MaxSubscriptionAmountSlider } from '../atomic-components/MaxSubscriptionAmountSlider';
import { LandRegisterMortgageStatusText } from '../atomic-components/LandRegisterMortgageStatusText';
import { ForumCheckbox } from '../atomic-components/ForumCheckbox';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';

export const AssetApprovalInvestmentDetails = () => {
  return (
    <LaunchpadCard title={'Investment Details'}>
      <TotalIssuePrice />
      <ExpertRatingTextField />
      <AppraisalFirmTextField />
      <ISINTextField />
      <SPVSelector />
      <IssueStartDatePicker />
      <IssueEndDatePicker />
      <IssueFundingFloorPercentageField />
      <SecurityTypeSelector />
      <AssetTypeConditional supported={['realEstate', 'powerplant', 'powerplantPortfolio', 'plot']}>
        <TerminationRightSelector />
        <TerminationRightFrequencySelector />
      </AssetTypeConditional>
      <AssetTypeConditional supported={['realEstate', 'powerplant', 'powerplantPortfolio', 'plot']}>
        <ForumCheckbox />
      </AssetTypeConditional>
      <AssetTypeConditional supported={['realEstate', 'powerplant', 'powerplantPortfolio', 'plot']}>
        <MaturityCheckbox />
      </AssetTypeConditional>
      <MaturityDatePicker />
      <LandRegisterMortgageStatusText />
      <MinSubscriptionAmountSlider />
      <AssetTypeConditional supported={['citizenParticipationLoan']}>
        <MaxSubscriptionAmountSlider />
      </AssetTypeConditional>
    </LaunchpadCard>
  );
};
